import React from 'react';
import BadNauheimLogo from '../../../assets/img/OrganizationLogos/BadNauheim-Logo.png';
import KemptenLogo from '../../../assets/img/OrganizationLogos/Kempten-Logo.png';
import LausitzLogo from '../../../assets/img/OrganizationLogos/MoveToLausitz-Logo.png';
import SIMALogo from '../../../assets/img/OrganizationLogos/SIMA-Logo.png';
import DietzenbachLogo from '../../../assets/img/OrganizationLogos/Dietzenbach-Logo.png';
import Rodgau from '../../../assets/img/OrganizationLogos/Rodgau-Logo.png';
import Ekom21Logo from '../../../assets/img/OrganizationLogos/Ekom21.png';
import { organization } from '../../../config/config';
import BadHomburgLogo from '../../../assets/img/OrganizationLogos/BadHomburg-Logo.png';
import RastattLogo from '../../../assets/img/OrganizationLogos/Rastatt-Logo.png';
import RotenburgLogo from '../../../assets/img/OrganizationLogos/Rotenburg-Logo.png';
import Demo from '../../../assets/img/logo-ui-square-dark.png';
import FrankenbergLogo from '../../../assets/img/OrganizationLogos/Frankenberg-Logo.png';
import ULILogo from '../../../assets/img/OrganizationLogos/ULI-Logo.png';
import FLIRLogo from '../../../assets/img/OrganizationLogos/FLIR-Logo.png';
import MobydexLogo from '../../../assets/img/OrganizationLogos/Mobidex-Logo.png';
import OffenburgLogo from '../../../assets/img/OrganizationLogos/Offenburg-Logo.png';
const logoMap: { [key: string]: string } = {
    'badnauheim': BadNauheimLogo,
    'kempten': KemptenLogo,
    'lausitz': LausitzLogo,
    'sima': SIMALogo,
    'dietzenbach': DietzenbachLogo,
    'rodgau': Rodgau,
    'movetolausitz': LausitzLogo,
    'ekom21': Ekom21Logo,
    'badhomburg': BadHomburgLogo,
    'rastatt': RastattLogo,
    'demo': Demo,
    'rotenburg': RotenburgLogo,
    'frankenberg': FrankenbergLogo,
    'uli': ULILogo,
    'flir': FLIRLogo,
    'mobydex': MobydexLogo,
    'offenburg': OffenburgLogo,

};

const OrganizationLogo: React.FC = () => {
    if (!organization || !logoMap[organization]) {
        return null;
    }

    const logoSrc = logoMap[organization];

    return (
        <img
            src={logoSrc}
            alt={`${organization} Logo`}
            style={{
                maxWidth: '80%',
                maxHeight: '2.5rem',
            } as React.CSSProperties}
        />
    );
};

export default OrganizationLogo;